export const MARKETS_FETCH = "markets_fetch";
export const MARKETS_FETCH_SUCCESSFUL = "markets_fetch_successfull";
export const MARKETS_FETCH_FAILED = "markets_fetch_failed";
